import { getFeatureFlagsStatus, isFlagsReadyFor, subscribeToFeatureFlags } from './launchDarklyClient'

import type { FeatureFlagsStatus } from './launchDarklyClient'
import { useSyncExternalStore } from 'react'

export type { FeatureFlagsStatus }

/**
 * Reports whether flag values are usable yet.
 *
 * Use this wherever "flag is off" and "flags have not loaded" must be told
 * apart — see `RouteSwitch`, which would otherwise act on the cold-load `false`
 * default and 404 a Propstack embed launch.
 *
 * `flagsReady` becomes true on every terminal outcome, including LaunchDarkly
 * being unconfigured or unreachable, so a caller that blocks on it cannot block
 * forever. Check `flagsError` to tell a real answer from a fallback one.
 */
export const useFeatureFlagsStatus = (): FeatureFlagsStatus =>
  useSyncExternalStore(
    subscribeToFeatureFlags,
    getFeatureFlagsStatus,
    getFeatureFlagsStatus
  )

/**
 * Whether flag values are final for `userId` — see `isFlagsReadyFor`. Use it
 * before acting on a flag that a rollout may target per user, where the
 * anonymous context's `false` must not be taken for the user's answer.
 */
export const useFeatureFlagsReadyFor = (userId?: string): boolean =>
  useSyncExternalStore(
    subscribeToFeatureFlags,
    () => isFlagsReadyFor(userId),
    () => isFlagsReadyFor(userId)
  )
